<table [hidden]="!viewGateways" class="table table-sm table-hover">
  <thead>
    <tr>
      <th> Gateways </th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (gateway of gateways; track gateway; let i = $index) {
      <tr>
        <td (click)="focusGateway(gateway)">{{gateway.title}} </td>
        <td>
          <div class="pull-right"> <i (click)="gotoGateway(gateway)" class="fa fa-chevron-right"></i></div>
        </td>
      </tr>
    }
  </tbody>
</table>